import { css } from '@adornis/chemistry/directives/css.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { html, nothing } from 'lit';
import { repeat } from 'lit/directives/repeat.js';

type TupleOfLength<T extends number, U = any> = T extends T ? [U, ...U[]] & { length: T } : never;

export function simpleInformationGrid<Cols extends number>(rows: Array<TupleOfLength<Cols, Renderable>>): Renderable {
  if (rows.length <= 0) return nothing;
  const columns = rows[0]?.length;
  if (!columns) return nothing;
  return html`
    <x-grid columns="${columns}" space="sm" ${css({ alignSelf: 'start' })}>
      ${repeat(
        rows,
        row => html`
          ${repeat(
            row,
            item => html` ${['number', 'string'].includes(typeof item) ? html`<x-text>${item}</x-text>` : item} `,
          )}
        `,
      )}
    </x-grid>
  `;
}
